import { useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip as TooltipChart,
  Legend,
  PointElement,
  LineElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  Title,
  TooltipChart,
  Legend,
  ChartDataLabels,
  PointElement,
);

const LineGraph = ({ labels, data }) => {
  const theme = useTheme();

  return (
    <Line
      options={{
        responsive: true,
        layout: {
          padding: 5,
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
          },
          title: {
            text: 'Pace',
          },
          datalabels: {
            font: {
              weight: 'bold',
              size: 14,
            },
            formatter: function(value, context) {
              return ``;
            },
          },
        },
        elements: {
          bar: {
            borderRadius: 12,
            borderSkipped: false,
          },
        },
        scales: {
          x: {
            display: true,
            ticks: {
              display: true,
              stepSize: Math.floor(labels?.length / 5),
            },
            grid: {
              display: false,
            },
            title: {
              display: true,
              text: 'Time (Seconds)',
            },
          },
          y: {
            display: true,
            ticks: {
              display: true,
              precision: false,
            },
            grid: {
              display: false,
            },
            title: {
              display: true,
              text: 'Words per minute',
            },
            min: 60,
            max: 400,
          },
        },
      }}
      data={{
        labels: labels,
        datasets: [
          {
            cubicInterpolationMode: 'monotone',
            label: 'Number of words',
            data: data,
            borderColor: theme.palette.primary.main,
            pointRadius: 1,
            pointHoverRadius: 1,
          },
        ],
      }}
    />
  );
};

LineGraph.propTypes = {
  labels: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  // competition: PropTypes.object.isRequired,
  // setShowCalendarModal: PropTypes.func.isRequired,
  // experiment: PropTypes.bool,
  // image: PropTypes.string,
  // blur: PropTypes.bool,
};

export default LineGraph;
